import { render, staticRenderFns } from "./frontLogin.vue?vue&type=template&id=2708f0e5&"
import script from "./frontLogin.vue?vue&type=script&lang=js&"
export * from "./frontLogin.vue?vue&type=script&lang=js&"
import style0 from "./frontLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports